import Animation from './animation'

/*
 * This animation is used when some series in a stack are unstacked. Columns
 * are added.
 */
class SplitAddAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = true
    this.ripple = true
  }

  match (serie) {
    if (!this.chart.previous) {
      return false // not an update
    }

    return this.chart.layout.columnCount() > this.chart.previous.layout.columnCount() ||
          ((this.chart.previous.layout.breakdown.calculated && this.chart.layout.breakdown.calculated) && // Previously and still in no-breakdown mode
          this.series.size() > this.previous.series.size()) // no breakdown style chart and series were added
  }

  animate (serie, entering, selection, merged) {
    this.chart.yTransition.duration(this.timing.duration) // Sync the y-axis w/ the left-most transition
                          .delay(this.timing.duration) // Don't move the y-axis until we start vertical movements

    this._insertZeroHeight(entering, serie)

    merged.delay(this.timing.delay)
          .duration(this.timing.duration)
          .tween('decorations', this.tweeners.decorations) // TODO See above. In the old code, I had to break this out and only update non-entering points?
          .tween('horizontal', this.tweeners.horizontal)
          .transition() // New transition for vertical movements, will inhert the same duration
          .tween('vertical', this.tweeners.vertical)
          .tween('decorations', this.tweeners.decorations)
  }

}

export default SplitAddAnimation
